import Cookie from "js-cookie";

type CookiesObjectType = typeof Cookie & {
  has(name: string): boolean
};

const Cookies = Cookie as CookiesObjectType;

Cookies.has = function(name: string) {
  const cookieChecked = this.get(name);
  if (cookieChecked !== '' && typeof cookieChecked !== 'undefined') {
    return true;
  }

  return false;
};


export default Cookies;
